<template>
    <v-row justify="start" class="flex-nowrap ma-n1" :class="{ 'mt-n3': isItemSequent }">
        <v-col cols="auto" class="pa-1" :style="{ opacity: isItemSequent ? 0 : 1 }">
            <v-avatar color="grey lighten-4" size="28px">
                <v-img>
                    <template #placeholder>
                        <v-icon small color="grey lighten-1"> mdi-robot </v-icon>
                    </template>
                </v-img>
            </v-avatar>
        </v-col>
        <v-col class="pa-1">
            <v-row align="end" class="ma-n1 flex-nowrap">
                <v-col cols="auto" class="pa-1" style="max-width: calc(100% - 36px)">
                    <v-card color="grey lighten-4" flat min-height="36">
                        <v-card-text class="py-2 px-3 text-caption" style="word-break: break-all">
                            {{ message?.content }}
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="auto" class="pa-1" :style="{ opacity: isTimeSequent ? 0 : 1 }">
                    <span class="text-caption">
                        {{ time }}
                    </span>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";
import { CHAT_MESSAGE_TYPES, initChatMessage } from "@/store/chat";

export default {
    props: {
        messages: { type: Array, default: () => [] },

        index: { type: Number, default: 0 },
        message: { type: Object, default: initChatMessage },
    },
    computed: {
        time() {
            return dayjs(this.message?.createdAt).format("HH:mm");
        },
        isItemSequent() {
            if (this.index == 0) return false;
            const prev = this.messages[this.index - 1];
            return [CHAT_MESSAGE_TYPES.PROMPT_ALERT.value, CHAT_MESSAGE_TYPES.PROMPT_REPLY.value].includes(prev?.type);
        },
        isTimeSequent() {
            if (this.index == this.messages.length - 1) return false;

            const next = this.messages[this.index + 1];
            if (![CHAT_MESSAGE_TYPES.PROMPT_ALERT.value, CHAT_MESSAGE_TYPES.PROMPT_REPLY.value].includes(next?.type)) return false;

            return dayjs(next?.createdAt).format("HH:mm") == this.time;
        },
    },
};
</script>

